import { render, staticRenderFns } from "./FormWrapper.vue?vue&type=template&id=18994aa1&"
import script from "./FormWrapper.vue?vue&type=script&lang=js&"
export * from "./FormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FormWrapper.vue?vue&type=style&index=0&id=18994aa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports